import * as React from 'react';

import {RenderedTextChunkState} from 'src/js/containers/document/document_slice';
import {ImmutableMap} from 'src/js/model/immutableMap';
import {Tag} from 'src/js/model/tag';

interface OwnProps {
  contextParams?: ImmutableMap;
  start: string | number;
  end: string | number;
  node: Tag;
  nodeData?: RenderedTextChunkState;
  elem: React.ComponentType;
  forceTransparent?: boolean;
}

type Props = OwnProps;

type DynamicNodePropsWithNodeData = Pick<
  OwnProps,
  'contextParams' | 'node' | 'start' | 'end' | 'forceTransparent' | 'nodeData'
>;

class DynamicNode extends React.PureComponent<Props> {
  static displayName = 'DynamicNode';

  static getStart(props) {
    return props.start || props.node.getStart();
  }

  static getEnd(props) {
    return props.end || props.node.getEnd();
  }

  render() {
    const {
      children,
      contextParams,
      elem,
      end,
      node,
      nodeData,
      start,
      forceTransparent,
    } = this.props;

    const props: DynamicNodePropsWithNodeData = {
      contextParams,
      node,
      start,
      end,
      forceTransparent,
    };

    // nodeData only if it is defined
    if (nodeData) {
      props.nodeData = nodeData;
    }

    return React.createElement<DynamicNodePropsWithNodeData>(
      elem,
      props,
      children
    );
  }
}

export default DynamicNode;
